// src/pages/TermsOfService.tsx: public terms of service at /terms (no auth).
import React from 'react';
import LegalPage, { H2, P, List, Mail } from '../components/LegalPage';

export default function TermsOfService() {
  return (
    <LegalPage title="Terms of Service" updated="30 August 2026">
      <H2>1. Introduction</H2>
      <P>
        These Terms of Service govern your access to and use of the Altveno
        alternative investment platform operated by Altveno Ltd. By using the
        Platform you agree to these Terms.
      </P>

      <H2>2. Eligibility</H2>
      <P>To use the Platform you must:</P>
      <List items={[
        'Be at least 18 years of age',
        'Be acting in a professional capacity',
        'For Managers: hold appropriate regulatory authorisation (FCA, SEC, MAS, DIFC, ADGM or equivalent)',
        'For Allocators: be a professional or institutional investor',
        'Not be in a jurisdiction where use is prohibited',
      ]} />

      <H2>3. Subscriptions and Fees</H2>
      <List items={[
        'Manager access: paid annually in advance, non-refundable, auto-renews with 30 days cancellation notice',
        'Allocator access: free for qualified institutional investors',
        'Service Provider access: subject to agreed listing fee',
        'Candidate access: free',
      ]} />

      <H2>4. Acceptable Use</H2>
      <P>You agree not to:</P>
      <List items={[
        'Use the Platform for any unlawful purpose',
        'Upload false or misleading information',
        'Share login credentials with any third party',
        'Scrape or extract data from the Platform',
        'Use automated tools to access the Platform',
        'Harass or harm other Platform users',
        'Facilitate market manipulation or financial crime',
      ]} />

      <H2>5. Content and Data</H2>
      <P>
        You retain ownership of all content you upload. By uploading you grant
        Altveno a licence to store and display it to operate the Platform. You are
        responsible for the accuracy of all content.
      </P>
      <P>
        You agree Altveno may use anonymised aggregated versions of your data to
        power AI tools.
      </P>

      <H2>6. No Investment Advice</H2>
      <P>
        Nothing on the Platform constitutes investment advice. Any investment
        decision following a Platform introduction is entirely at your own risk. You
        are responsible for your own due diligence.
      </P>

      <H2>7. Intellectual Property</H2>
      <P>
        The Platform is owned by Altveno and protected by intellectual property
        laws. You retain all rights to your own content.
      </P>

      <H2>8. Limitation of Liability</H2>
      <P>
        Altveno's total liability shall not exceed subscription fees paid in the
        prior 12 months. We are not liable for indirect losses, loss of profits or
        investment losses arising from Platform use.
      </P>

      <H2>9. Termination</H2>
      <P>
        You may terminate your account at any time by contacting <Mail />. We may
        terminate accounts immediately for breach of these Terms.
      </P>

      <H2>10. Governing Law</H2>
      <P>These Terms are governed by the laws of England and Wales.</P>

      <H2>11. Contact</H2>
      <P>Email: <Mail /></P>
    </LegalPage>
  );
}
